import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sysConfig:{},
  },
  //同步模式
  mutations: {
    changeSysConfig(state, newVal) { //携带参数newVal
      state.sysConfig = newVal
    },
  },
  //异步方法
  actions: {
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js